/**
 * GTM storefront dataLayer — runs in the main window (real _ga cookie).
 * Emits view_item, view_item_list (+ load-more), add_to_cart, remove_from_cart,
 * view_cart, search. begin_checkout is owned by the checkout pixel.
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  function push(payload) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  }

  function readJSON(el) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function emitEcommerce(selector, event) {
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.dataset.dlSent === 'true') return;
      var ecommerce = readJSON(el);
      if (!ecommerce || !ecommerce.items || !ecommerce.items.length) return;
      el.dataset.dlSent = 'true';
      push({ event: event, ecommerce: ecommerce });
    });
  }

  var lastListContext = null;

  function captureListContext() {
    var el = document.querySelector('[data-dl-view-item-list]');
    if (!el) return;
    var d = readJSON(el);
    if (d) lastListContext = { item_list_id: d.item_list_id, item_list_name: d.item_list_name };
  }

  function readAttrJSON(el) {
    try {
      return JSON.parse(el.getAttribute('data-gtm-item'));
    } catch (e) {
      return null;
    }
  }

  function pushListForCards(cards) {
    try {
      if (!cards.length) return;
      var grid = cards[0].closest('[data-load-more-grid]');
      var allCards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-gtm-item]')) : [];
      var items = [];
      cards.forEach(function (card) {
        if (card.dataset.dlListed === 'true') return;
        card.dataset.dlListed = 'true';
        var item = readAttrJSON(card);
        if (!item) return;
        var idx = allCards.indexOf(card);
        if (idx >= 0) item.index = idx;
        items.push(item);
      });
      if (!items.length) return;
      var ecommerce = { items: items };
      if (lastListContext) {
        ecommerce.item_list_id = lastListContext.item_list_id;
        ecommerce.item_list_name = lastListContext.item_list_name;
      }
      push({ event: 'view_item_list', ecommerce: ecommerce });
    } catch (e) {}
  }

  // Re-fire view_item_list for load-more/infinite-scroll appends. Observes the grid
  // AFTER products render, wrapped so a tracking error can never break the AJAX.
  function setupLoadMoreObserver() {
    if (typeof MutationObserver === 'undefined') return;
    document.querySelectorAll('[data-load-more-grid]').forEach(function (grid) {
      if (grid.dataset.dlObserved === 'true') return;
      grid.dataset.dlObserved = 'true';
      new MutationObserver(function (records) {
        try {
          var added = [];
          records.forEach(function (record) {
            Array.prototype.forEach.call(record.addedNodes, function (node) {
              if (node.nodeType !== 1) return;
              if (node.matches && node.matches('[data-gtm-item]')) added.push(node);
              else if (node.querySelector) {
                var inner = node.querySelector('[data-gtm-item]');
                if (inner) added.push(inner);
              }
            });
          });
          if (added.length) pushListForCards(added);
        } catch (e) {}
      }).observe(grid, { childList: true });
    });
  }

  // Re-emit view_item_list + re-wire the load-more observer after facets replace
  // the grid (filter / sort). The replacement's list tag is fresh, so it fires once.
  function refreshList() {
    emitEcommerce('[data-dl-view-item-list]', 'view_item_list');
    captureListContext();
    setupLoadMoreObserver();
  }

  function emitSearch() {
    document.querySelectorAll('[data-dl-search]').forEach(function (el) {
      if (el.dataset.dlSent === 'true') return;
      var d = readJSON(el);
      if (!d) return;
      el.dataset.dlSent = 'true';
      window.dataLayer.push({
        event: 'search',
        search_term: d.search_term,
        search_results_count: d.search_results_count,
      });
    });
  }

  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';
  var CART_UPDATE_URL = (window.routes && window.routes.cart_update_url) || '/cart/update.js';

  function money(cents) {
    return cents == null ? undefined : Math.round(cents) / 100;
  }

  // item_category = the collection a product was accessed through. Persisted as a
  // variant -> collection map on the cart (`_dl_collections`) so the cart events
  // and the checkout pixel share it.
  var currentCollection = null;
  var collectionMap = {};

  function readCollectionMap(cart) {
    try {
      var raw = cart && cart.attributes && cart.attributes._dl_collections;
      return raw ? JSON.parse(raw) || {} : {};
    } catch (e) {
      return {};
    }
  }

  var pendingPersist = null;
  function persistCollectionMap() {
    try {
      var p = fetch(CART_UPDATE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _dl_collections: JSON.stringify(collectionMap) } }),
      }).catch(function () {});
      pendingPersist = p;
      p.then(function () {
        if (pendingPersist === p) pendingPersist = null;
      });
      return p;
    } catch (e) {
      return Promise.resolve();
    }
  }

  // item_id mirrors gtm-dl-item.liquid + the pixel (sku, then variant id).
  function lineToItem(line, quantity) {
    var variantTitle = line.variant_title && line.variant_title !== '' ? line.variant_title : undefined;
    return {
      item_id: line.sku || String(line.id),
      item_name: line.product_title || line.title,
      item_brand: line.vendor || undefined,
      item_category: collectionMap[String(line.id)] || undefined,
      item_variant: variantTitle,
      price: money(line.final_price != null ? line.final_price : line.price),
      quantity: quantity != null ? quantity : line.quantity,
    };
  }

  function sumValue(items) {
    return items.reduce(function (total, i) {
      return total + (i.price || 0) * (i.quantity || 0);
    }, 0);
  }

  function itemsFromCart(cart) {
    return (cart.items || []).map(function (line) {
      return lineToItem(line);
    });
  }

  // Fire add_to_cart from a custom add flow (e.g. Buy Now) that doesn't publish
  // cartUpdate. Synchronous so it lands before a redirect. `lines` are /cart/add.js
  // response items (same shape as /cart.js lines).
  function trackAddToCart(lines) {
    try {
      lines = [].concat(lines || []).filter(Boolean);
      if (!lines.length) return Promise.resolve();
      var items = lines.map(function (line) {
        if (currentCollection && line.id != null) collectionMap[String(line.id)] = currentCollection;
        return lineToItem(line, line.quantity);
      });
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || undefined;
      // Push add_to_cart first so it always fires; then return the attribute write
      // so a caller (e.g. Buy Now) can wait for it before navigating.
      push({ event: 'add_to_cart', ecommerce: { currency: currency, value: sumValue(items), items: items } });
      return currentCollection ? persistCollectionMap() : Promise.resolve();
    } catch (e) {
      return Promise.resolve();
    }
  }
  window.gtmTrackAddToCart = trackAddToCart;

  function fetchCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  // add_to_cart / remove_from_cart derived by diffing /cart.js against a snapshot.
  var snapshot = null;
  var chain = Promise.resolve(); // serialize cart reads so the snapshot stays consistent

  function snapshotFrom(cart) {
    var map = {};
    (cart.items || []).forEach(function (line) {
      map[line.key] = { quantity: line.quantity, line: line };
    });
    return map;
  }

  function diffAndPush(cart) {
    var currency = cart.currency;
    var newMap = snapshotFrom(cart);
    var adds = [];
    var removes = [];
    var mapChanged = false;

    Object.keys(newMap).forEach(function (key) {
      var current = newMap[key];
      var previous = snapshot ? snapshot[key] : null;
      // Stamp the current page's collection onto added variants (only when we have one).
      if (!previous || current.quantity > previous.quantity) {
        if (currentCollection) {
          collectionMap[String(current.line.id)] = currentCollection;
          mapChanged = true;
        }
      }
      if (!previous) {
        adds.push(lineToItem(current.line, current.quantity));
      } else if (current.quantity > previous.quantity) {
        adds.push(lineToItem(current.line, current.quantity - previous.quantity));
      } else if (current.quantity < previous.quantity) {
        removes.push(lineToItem(current.line, previous.quantity - current.quantity));
      }
    });

    if (snapshot) {
      Object.keys(snapshot).forEach(function (key) {
        if (!newMap[key]) {
          var previous = snapshot[key];
          removes.push(lineToItem(previous.line, previous.quantity));
        }
      });
    }

    // Drop collection entries for variants no longer in the cart, so a later re-add
    // from a non-collection page doesn't reuse a stale collection.
    var present = {};
    (cart.items || []).forEach(function (line) {
      present[String(line.id)] = true;
    });
    Object.keys(collectionMap).forEach(function (vid) {
      if (!present[vid]) {
        delete collectionMap[vid];
        mapChanged = true;
      }
    });

    snapshot = newMap;

    if (adds.length) {
      push({ event: 'add_to_cart', ecommerce: { currency: currency, value: sumValue(adds), items: adds } });
    }
    if (removes.length) {
      push({ event: 'remove_from_cart', ecommerce: { currency: currency, value: sumValue(removes), items: removes } });
    }

    return mapChanged ? persistCollectionMap() : Promise.resolve();
  }

  function onCartUpdate() {
    chain = chain
      .then(fetchCart)
      .then(function (cart) {
        return cart && cart.items ? diffAndPush(cart) : undefined;
      })
      .catch(function () {});
    return chain;
  }

  function pushViewCart() {
    return fetchCart()
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) return;
        collectionMap = readCollectionMap(cart);
        push({
          event: 'view_cart',
          ecommerce: { currency: cart.currency, value: money(cart.total_price), items: itemsFromCart(cart) },
        });
      })
      .catch(function () {});
  }

  function run() {
    emitEcommerce('[data-dl-view-item]', 'view_item');
    emitEcommerce('[data-dl-view-item-list]', 'view_item_list');
    captureListContext();
    setupLoadMoreObserver();
    emitSearch();

    // Facets (filter / sort) swap #ProductGridContainer's innerHTML; re-run list
    // tracking on each replacement.
    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer && typeof MutationObserver !== 'undefined') {
      new MutationObserver(refreshList).observe(gridContainer, { childList: true });
    }

    // Product-linked options swap the product by inserting a new <main> (no page
    // load); re-emit the fresh view_item / view_item_list when that happens.
    var mainEl = document.querySelector('main');
    if (mainEl && mainEl.parentNode && typeof MutationObserver !== 'undefined') {
      new MutationObserver(function () {
        if (!document.querySelector('[data-dl-view-item]:not([data-dl-sent="true"]), [data-dl-view-item-list]:not([data-dl-sent="true"])')) return;
        emitEcommerce('[data-dl-view-item]', 'view_item');
        emitEcommerce('[data-dl-view-item-list]', 'view_item_list');
        captureListContext();
        setupLoadMoreObserver();
      }).observe(mainEl.parentNode, { childList: true });
    }

    var collEl = document.querySelector('[data-dl-collection]');
    if (collEl) {
      try {
        currentCollection = JSON.parse(collEl.textContent);
      } catch (e) {}
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      chain = chain
        .then(fetchCart)
        .then(function (cart) {
          if (cart) {
            snapshot = snapshotFrom(cart);
            collectionMap = readCollectionMap(cart);
          }
        })
        .catch(function () {});
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }

    if (document.getElementById('main-cart-items')) {
      pushViewCart();
    }

    // view_cart on cart drawer open (cart-drawer.open() adds .cart-drawer-open to <body>).
    var drawerOpen = document.body.classList.contains('cart-drawer-open');
    new MutationObserver(function () {
      var open = document.body.classList.contains('cart-drawer-open');
      if (open && !drawerOpen) pushViewCart();
      drawerOpen = open;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Wait for a pending collection-attribute write before checkout so item_category
    // reaches the checkout events (parity with Buy Now). Only delays when a write is in
    // flight; capped; checkout always proceeds.
    var bypassCheckout = false;
    document.addEventListener(
      'click',
      function (e) {
        if (bypassCheckout || !pendingPersist) return;
        var btn = e.target.closest && e.target.closest('[name="checkout"]');
        if (!btn) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        Promise.race([pendingPersist, new Promise(function (r) { setTimeout(r, 500); })]).then(function () {
          bypassCheckout = true;
          btn.click();
        });
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
